<div class="form-group" [formGroup]="form">
    <select id="{{filter.name}}" formControlName="{{filter.name}}" name="{{filter.name}}" class="form-control" (change)="change($event)">
    <option *ngIf="!filter.placeholder" value="">Selecciona una opción</option>
    <option *ngIf="filter.placeholder" value="">{{filter.placeholder}}</option>
    <option *ngFor="let option of filter.options" value="{{option.key}}">{{option.name}}</option>
  </select>
</div>